import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "title__inner" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "title__text" }
const _hoisted_5 = { class: "next-icon" }
const _hoisted_6 = { class: "value__text" }
const _hoisted_7 = { class: "value__text--unit" }

import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { DashboardGeneralSectionItem } from '../constants';
import { useInventoryDashboardStore } from '../pages/useInventoryDashboardStore';
import { storeToRefs } from 'pinia';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';

export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewSectionCard',
  props: {
    item: {}
  },
  setup(__props: any) {

const t = i18n.t;
const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const vm = new InventoryDashboardViewModel();

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: _ctx.item.to,
    class: _normalizeClass(["container", props.item.valueKey.length > 1 ? 'container--multi-value' : 'container--single-value'])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (props.item.icon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(Mdi, {
                  icon: props.item.icon.name,
                  variant: props.item.icon.variant,
                  style: _normalizeStyle(props.item.icon.style)
                }, null, 8, ["icon", "variant", "style"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(props.item.label)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Mdi, {
            class: "title__text",
            icon: "arrow_forward"
          })
        ])
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.valueKey, (value, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: value,
            class: "value"
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(vm).convertNumberToDisplayValue(value, _unref(state).overviewData[value])), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)(props.item.unit[index])), 1)
          ]))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["to", "class"]))
}
}

})